var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTheorigin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 24,
    viewBox: "0 0 122 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.4258 7.37256H75.9552V17.6401H82.4258V7.37256Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0623 10.9375C89.0623 10.01 89.8547 9.25499 90.834 9.25499C91.8133 9.25499 92.6056 10.0075 92.6056 10.9375C92.6056 11.8675 91.8133 12.62 90.834 12.62C89.8547 12.62 89.0623 11.8675 89.0623 10.9375ZM98.355 10.9375C98.355 7.90999 96.3675 5.32749 93.5665 4.28999V0.36499H88.0988V4.28749C85.2979 5.32749 83.3103 7.90749 83.3103 10.935C83.3103 14.88 86.6773 18.0775 90.8314 18.0775C90.8893 18.0775 90.9445 18.075 91.0025 18.0725V19.2425H84.1896V23.9975H97.4731V16.725H95.2329C97.123 15.4275 98.3524 13.3175 98.3524 10.935",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1905 0C77.2609 0 75.6972 1.485 75.6972 3.3175C75.6972 5.15 77.2609 6.6325 79.1905 6.6325C81.1201 6.6325 82.6838 5.1475 82.6838 3.3175C82.6838 1.4875 81.1201 0 79.1905 0Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 7.37256H99.2369V17.6401H105.708V7.37256Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.472 0C100.543 0 98.9789 1.485 98.9789 3.3175C98.9789 5.15 100.543 6.6325 102.472 6.6325C104.402 6.6325 105.966 5.1475 105.966 3.3175C105.966 1.4875 104.402 0 102.472 0Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.808 4.23499V17.6425H113.279V10.28C113.279 9.68998 113.781 9.21248 114.403 9.21248C115.024 9.21248 115.527 9.68998 115.527 10.28V17.6425H121.997V4.23499H106.808Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5807 12.62H55.0374V9.25504H58.5807V12.62ZM56.8091 3.79504C52.655 3.79504 49.2881 6.99254 49.2881 10.9375C49.2881 14.8825 52.655 18.08 56.8091 18.08C60.9631 18.08 64.3301 14.8825 64.3301 10.9375C64.3301 6.99254 60.9631 3.79504 56.8091 3.79504Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2146 17.64H71.6853V9.45999H74.9206V4.23499H65.2146V17.64Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3813 9.25499C38.358 9.25499 39.153 10.0075 39.153 10.9375C39.153 11.8675 38.3606 12.62 37.3813 12.62C36.402 12.62 35.6097 11.8675 35.6097 10.9375C35.6097 10.0075 36.402 9.25499 37.3813 9.25499ZM29.8208 12.5675C29.8208 15.5775 33.2483 17.64 35.1806 17.64H39.6532V14.4475H44.6101V4.23499H29.8208V12.57V12.5675Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.257 0.32251H13.7863V17.64H20.257V10.2775C20.257 9.68751 20.7598 9.21001 21.3811 9.21001C22.0023 9.21001 22.5051 9.68751 22.5051 10.2775V17.64H28.9758V4.23501H20.257V0.32251Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70598 0.32251H3.23533V4.23501H0V9.46001H3.23533V17.64H9.70598V9.46001H12.9413V4.23501H9.70598V0.32251Z",
    fill: "#B2B2B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheorigin);
export default __webpack_public_path__ + "static/media/theorigin.9b7fdd20cffd3efa5e41e26cbc178235.svg";
export { ForwardRef as ReactComponent };